import * as yup from "yup";

import { AccountantService, ClientService } from "../../../services";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedSnackbar,
	RHookFormDatePicker,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import {
	CLIENT_SETUP_SCREEN_SLUG,
	INITIAL_SNACKBAR_DATA,
} from "../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import {
	IGetListRequest,
	IResponse,
	IServerError,
} from "../../../models/common";
import React, { useEffect, useState } from "react";
import { formatDate, scrollPanelFieldsToTop, sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";
import { setSelectedClient, signInSuccess, signInUpdate } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { BasicSetupFormToolbar } from "../../BasicSetupFormToolbar";
import { CityService } from "../../../services/CityService";
import { ClientAddressSetupFieldsPanel } from "./Panles/ClientAddressSetupFieldsPanel";
import { ClientInfoSetupFieldsPanel } from "./Panles/ClientInfoSetupFieldsPanel";
import { ClientSetupToolbar } from "./ClientSetupToolbar";
import { ClientSetupValidationSchema } from "./validator";
import { ClientSuperUserManagementSetupFieldsPanel } from "./Panles/ClientSuperUserManagementSetupFieldsPanel";
import { CountryService } from "../../../services/common/CountryService";
import { GeneralSettingsService } from "../../../services/GeneralSettingsService";
import { Grid } from "@mui/material";
import { IAppState } from "../../../store/reducers";
import { IClient } from "../../../models";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedDashboardApisData } from "../../../store/actions/dashboardApisDataActions";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IClientSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "client-single-data-record";

const useGetData = (
	id: string | undefined,
	navigateToLogout: (path: string) => void,
	isAdminUser: number,
	superUserFieldsShownInClientSetup: boolean,
	clientId: string,
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, isAdminUser, superUserFieldsShownInClientSetup, clientId, id, navigateToLogout],
		queryFn: (data) => {
			return ClientService.getById(id, navigateToLogout, isAdminUser, superUserFieldsShownInClientSetup, clientId,);
		},
		refetchOnWindowFocus: false,
	});

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});

export const ClientSetup: React.FC<IClientSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	const isPendingActivityLogData = useSelector(
		(state: IAppState) => state.isLoadAxiosCall.isLoading
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const accountantstatus = useSelector(
		(state: IAppState) => state.accountant.status
	);
	const navigateToLogout = useNavigateToLogout();

	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const clientStoreId = useSelector((state: IAppState) => state.client.id);
	const companyAccountantName = useSelector(
		(state: IAppState) => state.user.profile.companyAccountantName
	);
	const { superUserFieldsShownInClientSetup } = useSelector((state: IAppState) => state.client)
	const [openDialog, setDialogOpen] = useState(false);
	const [isPendingData, setIsPendingData] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [clientId, setClientId] = useState<any>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [provinceStateDDLinUpdate, setProvinceStateDDLinUpdate] =
		useState(undefined);
	const [cityDDLinUpdate, setCityDDLinUpdate] = useState<any>(undefined);
	const [provinceStateLabelinUpdate, setProvinceStateLabelinUpdate] =
		useState<any>(undefined);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);
	const [defaultSelectedCountryState, setDefaultSelectedCountryState] = useState("")

	useEffect(() => {
		if (companyAccountantName !== null && isAdminUser === 200) {
			formMethods.setValue('legalName', companyAccountantName)
		}
	}, [companyAccountantName])

	useEffect(() => {
		if (clientStoreId && clientStoreId !== "") {
			let path = `/clients/setup/${clientStoreId}`
			navigate(path)
			setEditRecordId(clientStoreId)
		}
	}, [clientStoreId])

	const { isPending: isSubmitting, mutate: submitFormFields } = useMutation({
		mutationFn: ClientService.create,
		onSuccess: (res: IClient | IServerError | IResponse | any) => {


			if (res && res.status === 201) {
				setEditRecordId(res.id);
				queryClient.invalidateQueries({
					queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
				});
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});

				// call general settings to dave default settings 
				// (async () => {
				// 	let payload = {
				// 		clientId: res.data.id,
				// 		navigateToLogout: navigateToLogout,
				// 		repeatColumnHeading: 200,
				// 		timeFormat: 200,
				// 		employeeId: 300,
				// 		allEmployeesPaymentMethod: undefined,
				// 		vacationPayonPaidVacPay: 100,
				// 		payrollRemittancesMethod: 200,
				// 		vacationPayOnPaidVacPay: 100,
				// 		vacationPay: 200,
				// 		payoutVacationpay: 100,
				// 		commission: 100,
				// 		overtimeHours: 300,
				// 		edrFields: 200,
				// 		bonus: 200,
				// 		nonPeriodicPayment: 200,
				// 		retroactivePayIncrease: 200,
				// 		employeeSelectionInPayroll: 100,
				// 		hourlyPayRate: 100,
				// 		companyLogo: null,
				// 	};
				// 	try {
				// 		const response: any =
				// 			await GeneralSettingsService.create(
				// 				payload
				// 			);
				// 	} catch { }
				// })();
				scrollPanelFieldsToTop();
				// let path = `/clients/setup/${res.data.id}`;
				// navigate(path);
				// if (companyAccountantName !== null) {
				// 	dispatch(
				// 		signInUpdate({
				// 			user: { companyAccountantName: null },
				// 		})
				// 	);
				// }
				// alert(res.data.legalName)
				// dispatch(setSelectedClient({ id: res.data.id, legalName: res.data.legalName, superUserFieldsShownInClientSetup: superUserFieldsShownInClientSetup }));
				// dispatch(setSelectedDashboardApisData({ client_detail: res.data }));

				// navigate(`/clients/list`);
				navigate(`/accountants/clients`);
			} else if (res && res.status === 200) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				scrollPanelFieldsToTop();
				dispatch(setSelectedDashboardApisData({ client_deindetail: res.data }));
				if (companyAccountantName !== null) {
					dispatch(
						signInUpdate({
							user: { companyAccountantName: null },
						})
					);
				}
				// alert(res.data.legalName)
				dispatch(setSelectedClient({ id: res.data.id, legalName: res.data.legalName, superUserFieldsShownInClientSetup: superUserFieldsShownInClientSetup }));
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		editRecordId,
		navigateToLogout,
		isAdminUser,
		superUserFieldsShownInClientSetup,
		clientId,
	);

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();
	// let countryList = [
	// 	{
	// 		"shortCode": "CAN",
	// 		"value": "6718c0e02bd6872c87d35d0f",
	// 		"label": "Canada",
	// 		"countryType": "Province"
	// 	},
	// 	{
	// 		"logo": "",
	// 		"shortCode": "USA",
	// 		"value": "67496d974b9fb9f2ce4213b9",
	// 		"label": "United States of America",
	// 		"countryType": "state"
	// 	}
	// ]


	const ExtendedValidationSchema = ClientSetupValidationSchema.shape({
		postCode: yup.string().when("country", (country: any, schema: any) => {

			const selectedCountry = countryList.find(
				(c: any) => c.value === country[0]
			);

			if (selectedCountry?.shortCode === "CAN") {
				return schema
					.required("Postal Code is required")
					.length(6, "Postal Code must be exactly 6 characters");
			}
			return schema; // Unchanged for other countries
		}),
		zipCode: yup.string().when("country", (country: any, schema: any) => {
			const selectedCountry = countryList.find(
				(c: any) => c.value === country[0]
			);
			if (selectedCountry?.shortCode === "USA") {
				return schema
					.required("Zip Code is required")
					.length(5, "Zip Code must be exactly 5 characters");
			}
			return schema; // Unchanged for other countries
		}),
		scheduleStartDate: yup
			.string()
			.required("scheduleStartDate is required"),
	});

	const DEFAULT_VALUES = {
		companyId: undefined,
		legalName: undefined,
		operatingName: undefined,
		systemAlertsFrom: "",
		stubEmailFrom: "",
		craBusinessNo: undefined,
		status: 200,
		// invoicePaymentMethod: 100,
		//Super user management
		scheduleStartDate: null,
		transactionMethod: 200,
		isDirectDepositRequired: 200,
		remittanceManagement: 100,
		billingStartDate: null,
		billingStatus: 100,
		supportAccessLevelCanManager: 200,
		webROEManagedBySimplepay: 100,
		directDepositProcessing: 200,
		directDepositCycle: 200,
		journalCode: undefined,
		invoiceDeduction: 200,
		showAccountingToCompany: 200,
		activateAccount: 200,
		//Address Info
		addressLine1: undefined,
		// country: defaultSelectedCountryState,
		province: undefined,
		postCode: undefined,
		phone: undefined,
		phone2: undefined,
		tollFree: undefined,
		website: undefined,
	};
	const formMethods = useForm<any>({
		resolver: yupResolver(ExtendedValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES,
	});

	const onSubmit = async (values: any) => {

		const SelectedCountry = countryList.find(
			(e: any) => e.value === values.country
		);

		try {
			setIsPendingData(true);
			const ProvinceOrStateDDL = await CountryService.getProvinceOrStateDDL(
				navigateToLogout,
				SelectedCountry.value,
				SelectedCountry.countryType
			);
			const selectedProvinceOrState = values.province
				? ProvinceOrStateDDL.find((e: any) => e.value === values.province)
				: values.state
					? ProvinceOrStateDDL.find((e: any) => e.value === values.state)
					: undefined;

			const selectedCity = values.city && values.city && cityDDLinUpdate
				? cityDDLinUpdate.find((e: any) => e.value === values.city)
				: undefined;

			console.log("selectedCity", selectedCity);
			let payload = {
				id: id && id,
				isAdminUser: isAdminUser,
				navigateToLogout: navigateToLogout,
				accountantId: accountantId !== "0" ? accountantId : undefined,
				companyId: values.companyId,
				legalName: values.legalName,
				operatingName: values.operatingName,
				status:
					isAdminUser === 100 && selectedDataRecord && selectedDataRecord.status ? selectedDataRecord.status :
						isAdminUser === 100 ? 200 :
							isAdminUser === 200 && selectedDataRecord && selectedDataRecord.status ? selectedDataRecord.status :
								isAdminUser === 200 ? 200 :
									values.status,
				address: {
					countryType: values.province ? true : false,
					country: {
						id: SelectedCountry.value,
						name: SelectedCountry.label,
						shortCode: SelectedCountry.shortCode,
					},
					province: values.province
						? {
							id: selectedProvinceOrState.value,
							name: selectedProvinceOrState.label,
							shortCode: selectedProvinceOrState.shortCode,
						}
						: undefined,
					states: values.state
						? {
							id: selectedProvinceOrState.value,
							name: selectedProvinceOrState.label,
							shortCode: selectedProvinceOrState.shortCode,
						}
						: undefined,
					addressLine1: values.addressLine1,
					city: values.city,
					// city: values.city
					// 	? {
					// 		id: selectedCity.value,
					// 		name: selectedCity.label,
					// 	}
					// 	: undefined,
					// postCode: values.postCode ? values.postCode : undefined,
					postCode: values.postCode
						? values.postCode.replace(/[a-z]/g, (match: string) =>
							match.toUpperCase()
						)
						: undefined,
					zipCode: values.zipCode ? values.zipCode : undefined,
					// email: values.email,
					// stubEmailFrom: values.stubEmailFrom,
					stubEmailFrom:
						values.stubEmailFrom !== "" &&
							values.stubEmailFrom ? values.stubEmailFrom : undefined,
					phone: values.phone,
					phone2: values.phone2,
					website: values.website,
				},
				// invoicePaymentMethod: values.invoicePaymentMethod,
				systemAlertsFrom: values.systemAlertsFrom,
				tollFree: values.tollFree,
				craBusinessNo: values.craBusinessNo,
				scheduleStartDate:
					values.scheduleStartDate && values.scheduleStartDate !== "" ?
						formatDate(values.scheduleStartDate) : undefined,

				transactionMethod: values.paymentSetup,
				paymentSetup: values.paymentSetup,
				isDirectDepositRequired: values.isDirectDepositRequired,
				remittanceManagement: values.remittanceManagement,
				billingStartDate: values.billingStartDate !== null && values.billingStartDate !== "" ? formatDate(values.billingStartDate) : formatDate(new Date()),
				billingStatus: values.billingStatus,
				supportAccessLevelCanManager: values.supportAccessLevelCanManager,
				webROEManagedBySimplepay: values.webROEManagedBySimplepay,
				directDepositProcessing: values.directDepositProcessing,
				directDepositCycle: values.directDepositCycle,
				journalCode: values.journalCode,
				invoiceDeduction: values.invoiceDeduction,
				showAccountingToCompany: values.showAccountingToCompany,
				activateAccount: values.status,
			};


			//   alert(JSON.stringify(payloa''d, null, 2));
			submitFormFields(payload);
			console.log("payload", payload)
		} catch {

		} finally {
			setIsPendingData(false);
		}
	};

	useEffect(() => {

		if (id && selectedDataRecord) {
			Object.keys(selectedDataRecord).forEach((fieldName) => {
				// @ts-ignore
				const fieldValue = selectedDataRecord[fieldName];
				// @ts-ignore
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "address") {
					Object.keys(fieldValue).forEach((objFieldName) => {
						const objFieldValue = fieldValue[objFieldName];
						formMethods.setValue(objFieldName, objFieldValue ?? undefined);
						if (objFieldName === "countryType") {
							(async () => {
								try {
									setProvinceDDLLoading(true);
									const responce = await CountryService.getProvinceOrStateDDL(
										navigateToLogout,
										selectedDataRecord.address.country.id,
										objFieldValue ? "province" : "state"
									);

									setProvinceStateDDLinUpdate(responce);
									setProvinceStateLabelinUpdate(
										objFieldValue ? "province" : "state"
									);
								} catch {

								} finally {
									setProvinceDDLLoading(false);
								}
							})();
						}
						if (objFieldName === "country") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
						}
						if (objFieldName === "province") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
							(async () => {
								try {
									setProvinceDDLLoading(true);
									const responce = await CityService.getCityDDL(
										navigateToLogout,
										objFieldValue.id
									);

									setCityDDLinUpdate(responce);
								} catch {

									setProvinceDDLLoading(false);
								} finally {
									setProvinceDDLLoading(false);
								}
							})();
						}
						if (objFieldName === "state") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
						}
						if (objFieldName === "city") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
							// formMethods.setValue(objFieldName, objFieldValue ?? undefined);
						}
					});
				}
				if (fieldName === "scheduleStartDate") {
					if (fieldValue !== null) {
						const defaultDate = new Date(fieldValue);

						formMethods.setValue(fieldName, defaultDate);
					} else {
						formMethods.setValue(fieldName, fieldValue);
					}
				}
				if (fieldName === "billingStartDate") {
					if (fieldValue !== null) {
						const defaultDate = new Date(fieldValue);

						formMethods.setValue(fieldName, defaultDate);
					} else {
						formMethods.setValue(fieldName, fieldValue);
					}
				}
				// if (fieldName === 'countryType'){
				// 	(async()=>{
				// 	  try{
				// 		setProvinceDDLLoading(true)
				// 		const responce = await CountryService.getProvinceOrStateDDL(navigateToLogout,selectedDataRecord.address.country,fieldValue)
				// 		setProvinceStateDDLinUpdate(responce)
				// 		setProvinceStateLabelinUpdate(fieldValue)
				// 	  } catch {

				// 	  } finally {
				// 		setProvinceDDLLoading(false)
				// 	  }
				// 	})()
				//   }
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};
	const valuesss = formMethods.getValues()
	console.log("valueesss", valuesss)
	const { isPending: isDeleting, mutate: deleteClientById } = useMutation({
		mutationFn: ClientService.deleteById,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Client fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			// formMethods.reset();
			scrollPanelFieldsToTop();
			let path = `/clients/list`;
			navigate(path);
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteClientField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				clientId: clientId,
				navigateToLogout: navigateToLogout,
			};
			deleteClientById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setClientId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		formMethods.setValue("country", defaultSelectedCountryState)
		setTimeout(() => {
			formMethods.setValue("stubEmailFrom", undefined)
			formMethods.setValue("systemAlertsFrom", undefined)

		}, 1000)
		scrollPanelFieldsToTop();
		let path = `/clients/setup`;
		navigate(path);
	};

	// const { isPending, data } = useAccountants({
	//   search_query: "",
	//   order_by: "acc_title",
	//   order_direction: "asc",
	//   page: 1,
	//   size: 25,
	// });
	// const accountantList: any = data;
	// const enhanceData = (data: any[]): any[] => {
	// 	return data.map((item) => {
	// 		const enhancedItem = {
	// 			...item,
	// 			expanded: false,
	// 		};
	// 		return enhancedItem;
	// 	});
	// };
	const expandedLabels = ["Home"];
	const expandedLabelsInsideCompany = ["Company"];
	const expandedHomeClientSetupOrClientSetupItem = "Client Setup"; // Special case for "ClientSetup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			if (clientStoreId && clientStoreId !== "") {
				let isExpanded = expandedLabelsInsideCompany.includes(item.label);
				if (parentLabel === "Company" && item.label === "Setup") {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === "Setup" && `/clients/setup/${clientStoreId}`,
				};
				return enhancedItem;
			} else {
				let isExpanded = expandedLabels.includes(item.label);
				if (
					parentLabel === "Home" &&
					item.label === expandedHomeClientSetupOrClientSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedHomeClientSetupOrClientSetupItem && "/clients/setup",
				};
				return enhancedItem;
			}
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: id ? id : "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_SETUP_SCREEN_SLUG,
				accountantName: clientName,
				activityType:
					"activity_type=create&activity_type=updated&activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		//get client list drawer options
		// if(accountantList && accountantList.items && accountantList.items.length !== 0){
		//   // dispatch(setSelectedDrawerMenu({menu:ClientListRoutesWithAccountant}));
		//   const { ClientListRoutesWithAccountant } = ClientListRoutesWithAccountantComponent()
		//   // const enhancedItems = ClientListRoutesWithAccountant.map((item:any) => ({
		//   //   ...item,
		//   //   expanded: item.label === 'Home' ? true : false,
		//   // }));
		// } else {
		//     const { ClientListRoutes } = ClientListRoutesComponent()
		//   }
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);


	console.log('accountantstatus', accountantstatus)
	return (
		<Grid
			// sx={{ pb: "5rem", "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
			sx={{
				// mt: "1rem",
			}}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingData ||
					isPendingById ||
					isDeleting ||
					isPendingActivityLogData ||
					provinceDDLLoading
				}
				testId="accountant Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteClientField}
				cancelActionHandler={onCloseHandler}
				testId="accountant-confirmation-dialog"
			/>
			{isAdminUser !== 100 ?
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>
						<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<Grid
								size={{ xs: 12, sm: 12, md: 8.5, lg: 8, xl: 8 }}
								sx={
									{
										// border: "1px solid rgba(0, 0, 0, 0.12)",
										// borderRadius: "3px",
										// marginTop: "16px",
										// background: "#ffffff",
									}
								}
							>
								<TwoColumnLayout
									toolbar={
										// <ClientSetupToolbar
										// 	onResetClicked={onResetClicked}
										// 	onDeleteClicked={onDeleteClicked}
										// 	isSubmitting={isSubmitting}
										// 	id={id}
										// />
										<BasicSetupFormToolbar
											onResetClicked={onResetClicked}
											onDeleteClicked={onDeleteClicked}
											isSubmitting={isSubmitting}
											id={id}
											pageTitle={"Clients"}
										/>
									}
									leftColumnContent={
										<>
											<StandardPanel
												title="Company Info"
												testId={`client-info`}
												variant="outlined"
												borderHide={true}
												borderBottom={
													clientStoreId === undefined || clientStoreId === ""
														? true
														: false
												}
											>
												<ClientInfoSetupFieldsPanel
													clientStoreId={clientStoreId}
													selectedDataRecord={selectedDataRecord}
													isAdminUser={isAdminUser}
													savedStatus={selectedDataRecord && selectedDataRecord.status === 100 ? "Active" :
														selectedDataRecord && selectedDataRecord.status === 200 ? "InActive" : ""
													}
													id={id && id}
												/>
											</StandardPanel>
											{/* {clientStoreId !== undefined && "" ? (
										<></>
									) : (
										<StandardPanel
											title="Super user management"
											testId={`client-third`}
											
											variant="outlined"
											borderHide={true}
										>
											<ClientSuperUserManagementSetupFieldsPanel
												isAdminUser={isAdminUser}
											/>
										</StandardPanel>
									)} */}
											{/* {clientStoreId === undefined || clientStoreId === "" ? ( */}
											{isAdminUser === 400 && superUserFieldsShownInClientSetup && !clientId && <StandardPanel
												title="Super user management"
												testId={`client-third`}
												variant="outlined"
												borderHide={true}
												borderTop={true}
											>
												<ClientSuperUserManagementSetupFieldsPanel
													isAdminUser={isAdminUser}
													selectedDataRecord={selectedDataRecord}
												/>
											</StandardPanel>}
											{/* ) : (
											<></>
										)} */}
										</>
									}
									rightColumnContent={
										<>
											<StandardPanel
												title="Address Info"
												testId={`client-address-info`}
												variant="outlined"
												borderHide={true}
											>
												<ClientAddressSetupFieldsPanel
													testId={"client-address-info"}
													countryList={countryList}
													formMethods={formMethods}
													provinceDDLLoading={(value: boolean) =>
														setProvinceDDLLoading(value)
													}
													provinceStateLabelinUpdate={
														provinceStateLabelinUpdate &&
														provinceStateLabelinUpdate
													}
													provinceStateDDLinUpdate={
														provinceStateDDLinUpdate && provinceStateDDLinUpdate
													}
													cityDDLinUpdate={cityDDLinUpdate && sortDDLByLabel(cityDDLinUpdate)}
													isAdminUser={isAdminUser}
													clientStoreId={clientStoreId}
													loadedClientId={id && id}
													// loadedClientId={selectedDataRecord && selectedDataRecord}
													setDefaultSelectedCountry={(selectedCountry: any) => setDefaultSelectedCountryState(selectedCountry)}
												/>
											</StandardPanel>
										</>
									}
									testId="t4-slip-setup-form"
								// toolbarPosition="bottom"
								/>
							</Grid>
						</Grid>
					</form>
				</FormProvider> :
				isAdminUser === 100 && accountantstatus && accountantstatus === "Active" ?
					<FormProvider {...formMethods}>
						<form onSubmit={formMethods.handleSubmit(onSubmit)}>
							<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
								<Grid
									size={{ xs: 12, sm: 12, md: 8.5, lg: 8, xl: 8 }}
									sx={
										{
											// border: "1px solid rgba(0, 0, 0, 0.12)",
											// borderRadius: "3px",
											// marginTop: "16px",
											// background: "#ffffff",
										}
									}
								>
									<TwoColumnLayout
										toolbar={
											// <ClientSetupToolbar
											// 	onResetClicked={onResetClicked}
											// 	onDeleteClicked={onDeleteClicked}
											// 	isSubmitting={isSubmitting}
											// 	id={id}
											// />
											<BasicSetupFormToolbar
												onResetClicked={onResetClicked}
												onDeleteClicked={onDeleteClicked}
												isSubmitting={isSubmitting}
												id={id && id}
												pageTitle={"Clients"}
											/>
										}
										leftColumnContent={
											<>
												<StandardPanel
													title="Company Info"
													testId={`client-info`}
													variant="outlined"
													borderHide={true}
												// borderBottom={
												// 	clientStoreId === undefined || clientStoreId === ""
												// 		? true
												// 		: false
												// }
												>
													<ClientInfoSetupFieldsPanel
														clientStoreId={clientStoreId}
														selectedDataRecord={selectedDataRecord}
														isAdminUser={isAdminUser}
														savedStatus={selectedDataRecord && selectedDataRecord.status === 100 ? "Active" :
															selectedDataRecord && selectedDataRecord.status === 200 ? "InActive" : ""
														}
														id={id && id}
													/>
													<RHookFormDatePicker
														name="scheduleStartDate"
														testId="Schedule Start Date"
														label="Schedule Start Date"
														format="M dd, yy"
													/>
												</StandardPanel>
											</>
										}
										rightColumnContent={
											<>
												<StandardPanel
													title="Address Info"
													testId={`client-address-info`}
													variant="outlined"
													borderHide={true}
												>
													<ClientAddressSetupFieldsPanel
														testId={"client-address-info"}
														countryList={countryList}
														formMethods={formMethods}
														provinceDDLLoading={(value: boolean) =>
															setProvinceDDLLoading(value)
														}
														provinceStateLabelinUpdate={
															provinceStateLabelinUpdate &&
															provinceStateLabelinUpdate
														}
														provinceStateDDLinUpdate={
															provinceStateDDLinUpdate && provinceStateDDLinUpdate
														}
														cityDDLinUpdate={cityDDLinUpdate && sortDDLByLabel(cityDDLinUpdate)}
														isAdminUser={isAdminUser}
														clientStoreId={clientStoreId}
														loadedClientId={id}
														setDefaultSelectedCountry={(selectedCountry: any) => setDefaultSelectedCountryState(selectedCountry)}

													/>
												</StandardPanel>
											</>
										}
										testId="t4-slip-setup-form"
									// toolbarPosition="bottom"
									/>
								</Grid>
							</Grid>
						</form>
					</FormProvider> :
					isAdminUser === 100 && accountantstatus && accountantstatus !== "Active" ?
						<>
							<EnhancedSnackbar
								message={"Your account is not active yet, You will be able to add company once its active."}
								onCloseHandler={onSnackbarClosed}
								severity={"warning"}
								testId={"accountant-snackbar"}
								open={true}
								autoHide={false}
							/>
						</> : <></>}
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
